import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\CreateDossierController::__invoke
* @see app/Http/Controllers/Dossier/CreateDossierController.php
* @route '/api/dossier'
*/
const CreateDossierController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierController.url(options),
    method: 'post',
})

CreateDossierController.definition = {
    methods: ["post"],
    url: '/api/dossier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\CreateDossierController::__invoke
* @see app/Http/Controllers/Dossier/CreateDossierController.php
* @route '/api/dossier'
*/
CreateDossierController.url = (options?: RouteQueryOptions) => {
    return CreateDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\CreateDossierController::__invoke
* @see app/Http/Controllers/Dossier/CreateDossierController.php
* @route '/api/dossier'
*/
CreateDossierController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierController.url(options),
    method: 'post',
})

export default CreateDossierController